<form #nativeForm
      class="td-wb-signal-form__form"
      [formRoot]="formTree()"
      (submit)="onNativeSubmit()">
  <div class="td-wb-vh"
       role="region"
       [attr.aria-labelledby]="accessibleHeaderId"
       [attr.aria-hidden]="!hasErrors()">
    @if (hasErrors()) {
      <h2 [id]="accessibleHeaderId">{{ 'tdWb.formAccessibility.ERRORS_ARIA' | tdWbTranslate }}</h2>
    }
    <td-wb-form-accessibility-alert [attr.aria-hidden]="!hasErrors()" />
  </div>
  <ng-content />
</form>


